document.addEventListener('DOMContentLoaded', function () {
    const banners = document.querySelectorAll('.hero');
    banners.forEach(banner => {
        const swiperContainer = banner.querySelector('.hero-swiper');
        const nextBtn = banner.querySelector('.hero-nav-btn.swiper-button-next');
        const prevBtn = banner.querySelector('.hero-nav-btn.swiper-button-prev');

        if (swiperContainer) {
            const slideCount = swiperContainer.querySelectorAll('.swiper-slide').length;
            const isSingle = slideCount <= 1;
            //const isSingle = 1;

            new Swiper(swiperContainer, {
                loop: !isSingle,
                allowTouchMove: !isSingle,
                autoHeight: window.innerWidth <= 991,
                navigation: isSingle ? false : {
                    nextEl: nextBtn,
                    prevEl: prevBtn,
                },
                pagination: {
                    el: banner.querySelector('.swiper-pagination'),
                    clickable: true,
                },
                effect: window.innerWidth > 991 ? 'fade' : 'slide',
                fadeEffect: {
                    crossFade: true
                }
            });

            // Hide navigation wrapper if there is only 1 slide
            if (isSingle) {
                const navWrapper = banner.querySelector('.hero-nav-wrapper');
                if (navWrapper) {
                    navWrapper.style.display = 'none';
                }
            }
        }
    });
});
